/**
 * Pricing table
 */

( function() {
	console.log('pricing.js loaded');
	// Grab the prices
	const prices = document.querySelectorAll('.coeff-pricing-price');

	// Grab the control
	const pricingTableSwitch = document.querySelector('.coeff-pricing-switch input');

	// Check for both and bail if not found
	if (!prices || !pricingTableSwitch) return;

	// Grab the labels
	const pricingTableLabels = document.querySelectorAll('.coeff-pricing-toggle-label-wrapper');

	// Now lets monitor the switch
	pricingTableSwitch.addEventListener('click', function() {
		// Grab the current checked state
		let priceModel = this.checked ? 'annually' : 'monthly';

		// Now lets grab all the prices
		prices.forEach((price) => {
			// Now lets grab the two prices from the data-monthly and data-yearly attributes
			let monthlyPrice = price.getAttribute('data-monthly');
			let yearlyPrice = price.getAttribute('data-yearly');

			// Now lets flip those prices based on the current state of the switch
			const newPrice = priceModel === 'annually' ? yearlyPrice : monthlyPrice;

			// Now lets update the price
			price.innerHTML = '$' + newPrice;
		});

		// Now lets swap the active between the two labels
		pricingTableLabels.forEach((label) => {
			// Check if the label has the active class
			if (label.classList.contains('active')) {
				// Remove the active class
				label.classList.remove('active');
			} else {
				// Add the active class
				label.classList.add('active');
			}
		});
	});
}() );